import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text, Badge } from 'modules/common';

import * as c from './constants';

function BreadcrumbItem({
  leadingItem,
  withLeading,
  withBadge,
  label,
  type,
  isActive,
  disabled,
  badgeProps,
  onClick,
}) {
  let $type = c.TYPE_OPTS({ isActive, type });
  $type = disabled ? $type?.disabled : $type?.[type];

  const style = {
    text: $type?.text,
  };

  return (
    <div className="inline-block">
      <div
        className={cn(
          'gap-ds-8 rounded flex items-center cursor-pointer',
          style.text
        )}
        onClick={onClick}
        role="presentation"
      >
        {withLeading && leadingItem}

        <Text className="py-[3px]" weight="semibold">
          {label}
        </Text>

        {withBadge && (
          <Badge
            type="danger"
            disabled={disabled}
            withLeading={false}
            withClose={false}
            className="!gap-0"
            {...badgeProps}
          />
        )}
      </div>
    </div>
  );
}

BreadcrumbItem.defaultProps = {
  type: 'default',
  isActive: false,
  label: '',
  leadingItem: false,
  withBadge: false,
  disabled: false,
  badgeProps: {},
  onClick: () => {},
  withLeading: true,
};

const PROP_TYPES_TYPE = Object.keys(c.TYPE_OPTS())?.filter(
  (item) => item !== 'disabled'
);

BreadcrumbItem.propTypes = {
  type: PropTypes.oneOf(PROP_TYPES_TYPE),
  label: PropTypes.string,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.instanceOf(Function),
  leadingItem: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  withBadge: PropTypes.bool,
  badgeProps: PropTypes.instanceOf(Object),
  withLeading: PropTypes.bool,
};

export default BreadcrumbItem;
